"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FirstVizSizeKnownEvent {
    constructor(vizSize) {
        this._vizSize = vizSize;
    }
    get vizSize() {
        return this._vizSize;
    }
}
exports.FirstVizSizeKnownEvent = FirstVizSizeKnownEvent;
//# sourceMappingURL=FirstVizSizeKnownEvent.js.map